"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports["default"] = exports.TestSelect = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.array.map");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _propValidators = require("../utils/propValidators");

var _forwardRef = _interopRequireDefault(require("../utils/forwardRef"));

var _HelperText = _interopRequireDefault(require("../HelperText"));

var _htmlAttributesAllowlistProps = _interopRequireDefault(require("../utils/htmlAttributesAllowlistProps"));

var _splitWrapperAndElementProps = _interopRequireDefault(require("../utils/splitWrapperAndElementProps"));

var _withId = _interopRequireDefault(require("../utils/withId"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function getValue(propsValue, stateValue) {
  if (typeof propsValue !== 'undefined') {
    // passing null as the value to <select /> will result in an error
    // to provide a common experience across components change null to empy string
    if (propsValue === null) {
      return '';
    }

    return propsValue;
  }

  return stateValue;
}

var propTypes = {
  className: _propTypes["default"].string,
  compact: _propTypes["default"].bool,
  defaultValue: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  error: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].node]),
  forwardedRef: _propTypes["default"].exact({
    current: typeof HTMLSelectElement !== 'undefined' ? _propTypes["default"].instanceOf(HTMLSelectElement) : _propTypes["default"].elementType
  }),
  helper: _propTypes["default"].node,
  hideLabel: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  label: _propValidators.accessibleLabelType.isRequired,
  onChange: _propTypes["default"].func,
  // TODO - key and style were originally not included in this shape. Should they be? Options can't really have styles...
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    key: _propTypes["default"].string,
    label: _propTypes["default"].string,
    style: _propTypes["default"].object,
    value: _propTypes["default"].string
  })),
  placeholder: _propTypes["default"].string,
  value: _propTypes["default"].string
};
var defaultProps = {
  compact: false,
  defaultValue: '',
  disabled: false,
  error: false,
  hideLabel: false,
  onChange: function onChange() {},
  options: [],
  placeholder: ''
};

var Select = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Select, _Component);

  function Select(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleChange = function (event) {
      var onChange = _this.props.onChange;
      var value = event.target.value;

      _this.setState({
        value: value
      });

      onChange(event);
    };

    _this.state = {
      value: props.value || props.defaultValue
    };
    return _this;
  }

  var _proto = Select.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        label = _this$props.label,
        options = _this$props.options,
        disabled = _this$props.disabled,
        id = _this$props.id,
        className = _this$props.className,
        compact = _this$props.compact,
        error = _this$props.error,
        helper = _this$props.helper,
        placeholder = _this$props.placeholder,
        onChange = _this$props.onChange,
        propsValue = _this$props.value,
        defaultValue = _this$props.defaultValue,
        hideLabel = _this$props.hideLabel,
        forwardedRef = _this$props.forwardedRef,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["label", "options", "disabled", "id", "className", "compact", "error", "helper", "placeholder", "onChange", "value", "defaultValue", "hideLabel", "forwardedRef"]);

    var stateValue = this.state.value;
    var value = getValue(propsValue, stateValue);
    var classes = (0, _classnames["default"])('grv-form-field', {
      'grv-form-field--compact': compact
    }, className);
    var selectClasses = (0, _classnames["default"])('grv-select__input', {
      'grv-select__input--compact': compact,
      'grv-select__input--error': error,
      'grv-select__input--no-selection': !value
    });
    var labelClasses = (0, _classnames["default"])('grv-label', 'grv-label--select', {
      'grv-label--compact': compact,
      'grv-label--disabled': disabled,
      'grv-visually-hidden': hideLabel
    });

    var _splitWrapperAndEleme = (0, _splitWrapperAndElementProps["default"])(otherProps, 'select'),
        wrapperProps = _splitWrapperAndEleme[0],
        selectProps = _splitWrapperAndEleme[1];

    return /*#__PURE__*/_react["default"].createElement("div", _extends({}, wrapperProps, {
      /* omittedProps will be applied to a child component */
      className: classes
    }), /*#__PURE__*/_react["default"].createElement("label", {
      className: labelClasses,
      htmlFor: id
    }, label), /*#__PURE__*/_react["default"].createElement("div", {
      className: "grv-select__wrapper"
    }, /*#__PURE__*/_react["default"].createElement("select", _extends({}, selectProps, {
      className: selectClasses,
      disabled: disabled,
      id: id,
      onChange: this.handleChange,
      ref: forwardedRef,
      value: value
    }), /*#__PURE__*/_react["default"].createElement("option", {
      value: ""
    }, placeholder), options.map(function (option) {
      return /*#__PURE__*/_react["default"].createElement("option", _extends({}, (0, _htmlAttributesAllowlistProps["default"])('option', option), {
        key: option.key || option.value,
        style: option.style,
        value: option.value
      }), option.label);
    }))), /*#__PURE__*/_react["default"].createElement(_HelperText["default"], {
      error: true,
      content: error,
      type: "select"
    }), /*#__PURE__*/_react["default"].createElement(_HelperText["default"], {
      content: helper,
      type: "select"
    }));
  };

  return Select;
}(_react.Component);

Select.propTypes = propTypes;
Select.defaultProps = defaultProps;
var TestSelect = Select;
exports.TestSelect = TestSelect;

var _default = (0, _forwardRef["default"])((0, _withId["default"])(Select));

exports["default"] = _default;